import styled from 'styled-components'

export const GridContainer = styled.section`
    display: grid;
    background-color: white;
    height: 100%;
    grid-template-rows: 150px 1fr 60px;
    grid-template-areas:
        'header'
        'main'
        'footer';
`

export const FullHeaderContainer = styled.div`
    background: #ffffff;
    grid-area: header;
`

export const HeaderLinkCreate = styled.div`
    border-bottom: 1px solid #dee2e6;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;
    padding: 16px;
`

export const Title = styled.h1`
    max-width: 80%;
    max-height: 100%;
    flex-wrap: wrap;
    word-break: break-word;
    overflow: hidden;
    font-size: 22px;
    margin: 0;
    color: #333;
    font-family: 'Inter';
    font-weight: 500;
`

export const StepperNav = styled.nav`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
`

export const FormDiv = styled.form`
    grid-area: main;
    /* display: grid; */
    margin-top: 15px;
    /* padding: 15px 120px; */
    /* display: flex; */
    /* flex-direction: column; */
    /* margin: 0 auto; */
    /* min-width: 1200px; */
    padding: 10px 30px;
    overflow: scroll;
    overflow-x: hidden;

    @media (min-width: 768px) {
        /* padding: 10px 60px; */
        padding: 15px 60px;
    }

    @media (min-width: 1000px) {
        /* padding: 10px 60px; */
        padding: 15px 120px;
    }

    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 14px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }

    h3 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 29px;
    }
`

export const TitleForm = styled.h2`
    font-size: 1.5rem;
    font-family: 'Inter';
    line-height: 1.2;
    font-weight: 600;
`

export const Form = styled.form`
    /* margin-bottom: 15px; */

    /* .input-group {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }  */
`

export const FooterLink = styled.footer`
    grid-area: footer;
    background: #ffffff;
    padding: 10px;
    border-top: 1px solid #dee2e6;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
`

export const ButtonNext = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    color: #ffffff;
    background-color: #08267d;
    border-color: #0030b9;

    display: inline-flex;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
`

export const ButtonFinish = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    color: #ffffff;
    background-color: #28a745;
    border-color: #13c02e;

    display: inline-flex;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    &:disabled {
        opacity: 0.5;
    }
`

export const ButtonBack = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    display: inline-flex;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;
`

export const PaymentTypeDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap: 24px;
`

export const Type = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;

    height: 121px;
    width: 182px;
    box-sizing: border-box;
    background: #fcfcfc;
    border: 1px solid #d3d3d3;
    border-radius: 10px;
    gap: 6px;

    & p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
    }
`

export const IconType = styled.img`
    margin-top: 16px;
`

export const ExplainText = styled.h4`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;

    margin-top: 11px;
    margin-bottom: 20px;
    color: #7e7979;
`

export const FrequencyPayment = styled.h3`
    margin-bottom: 10px;
`

export const SummarySection = styled.section`
    /* margin-top: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    h2.title {
        text-align: center;
    }
`

export const InfoPayment = styled.div`
    padding: 26px 62px;
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    background: #fdfdfd;
    border: 1px solid #d3d3d3;
    border-radius: 10px;

    h4 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        line-height: 29px;

        color: #676767;
    }

    h5 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        display: flex;
        align-items: center;

        color: #000000;
    }
`

export const InfoAndEdit = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 25px;

    h2 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 34px;

        color: #011e5b;
    }
`

export const InfoAndEdit2 = styled.div`
    margin-top: 10px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 25px;

    h2 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 34px;

        color: #011e5b;
    }
`

export const Edit = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    span {
        font-size: 16px;
        font-weight: 400;
        color: #0030b9;
        line-height: 1.5;
        cursor: pointer;
    }
`

export const ReceiverValue = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 25px;

    h4 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        line-height: 29px;

        color: #676767;
    }

    h3 {
        color: #212529;
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 1.5;
    }
`
